import styled from 'styled-components/macro';
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack
} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useCommunities, useCommunitySubscribe} from "../api/communities";
import CommunityLogo from "./community_logo";
import {useHistory} from "react-router-dom";
import {themecolors} from "../utils/themecolors";

const CommunityName = styled.div``;
const Political = styled.div``;
const JoinContainer = styled.div``;
const Join = styled.div``;
const LogoContainer = styled.div``;
const TextContainer = styled.div``;
const Description = styled.div``;
const ViewMore = styled.div``;

const Onboarding = styled(({className, onClose}) => {

    const feedback = useFeedback();
    const communities = useCommunities(feedback.channel, ["Memes", "InsaneVideos", "Animals", "vids",
        "TheDonald", "Immigration", "Gaming", "KotakuInAction2", "ShitRedditSays", "GreatAwakening", "FatPeopleHate", "MenInDresses", "ConsumeProduct"]);

    const history = useHistory();
    const handleCommunities = () => {
        onClose();
        history.push("/communities?sort=topics&topic=recommended");
    }

    return (
        <>
            <Modal
                isOpen
                onClose={onClose}
                closeOnOverlayClick={false}
                size={'xl'}
            >
                <ModalOverlay/>
                <ModalContent className={className}>
                    <ModalHeader>Join Communities</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody pb={6}>

                        <Stack spacing={'5'} maxH={'340px'} overflow={'scroll'}>
                            {communities?.map((community) => community && (
                                <Community
                                        key={community?.name}
                                        community={community}
                                    />
                            ))}
                            <ViewMore onClick={handleCommunities}>
                                View all communities
                            </ViewMore>
                        </Stack>

                    </ModalBody>

                    <ModalFooter>
                        <Button variant="cancel" mr={3} onClick={onClose}>Skip</Button>
                        <Button variant="blue" isLoading={false} onClick={onClose}>
                            Done
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
})`
  ${ViewMore} {
    cursor: pointer;
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_2};
    font-size: 15px;
  }
`;

const Community = styled(({className, community}) => {

    const {feedbackCh, error} = useFeedback();
    const subscribe = useCommunitySubscribe(feedbackCh);

    const handleSubscribe = async (name) => {
        try {
            await subscribe([name]);
        } catch {
        }
    }

    return (
        <div className={className}>
            <LogoContainer>
                <CommunityLogo name={community.name} data={community} />
            </LogoContainer>
            <TextContainer>
                <CommunityName>{community.display_name}</CommunityName>
                <Description>{community.description}</Description>
            </TextContainer>
            <JoinContainer>
                {!community.is_subscribed &&
                    <Join onClick={() => handleSubscribe(community.name)}>Join</Join>
                }
            </JoinContainer>
        </div>
    )
})`
  display: flex;
  ${Political} {
    font-size: 14px;
  }
  ${CommunityName} {
    font-weight: 500;
    font-size: 16px;
  }
  ${JoinContainer} {
    margin-left: auto;
    margin-right: 16px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  ${Join} {
    cursor: pointer;
    font-weight: 500;
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#f3f3f3' : '#0c0c0c'};
    color: ${({theme}) => theme.color.name === 'dark' ? '#1e1e1e' : '#fff'};
    border-radius: 48px;
    font-size: 15px;
    padding: 4px 16px;
  }
  img {
    margin-right: 12px;
    border-radius: 48px;
    width: 36px;
    height: 36px;
  }
  ${LogoContainer}, ${TextContainer} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  ${LogoContainer} {
    flex-shrink: 0;
  }
  ${Description} {
    font-size: 14px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
`;

export default Onboarding;
